import URI from "URIjs";


class Path {
  constructor(path, host, params={}, secure=true) {
    this.path = path;
    this.host = host;
    this.secure = secure;
    this.queryParams = params;

    // We are dealing with a fully-qualified URL as a path, encode it
    if (this.path.indexOf("http") === 0) {
      this.path = URI.encode(this.path);
    }

    if (this.path[0] !== "/") {
      this.path = "/" + this.path;
    }
  }

  toString() {
    const uri = new URI({
      protocol: this.secure ? "https" : "http",
      hostname: this.host,
      path: this.path,
      query: URI.buildQuery(this.queryParams)
    });
    return uri.toString();
  }
}

export default class Client {
  constructor(host, secure=true) {
    this.host = host;
    this.secure = secure;
  }

  path(urlPath, params={}) {
    return new Path(urlPath, this.host, params, this.secure);
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/imgix.js
 **/